export default __webpack_public_path__ + "static/media/diamond-heart-shape.ecde38ba.svg";